import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { redirectAuthenticatedGuard } from './auth/redirect-authenticated.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./landing/landing').then((m) => m.LandingComponent),
  },
  {
    path: 'acceso-solicitado',
    loadComponent: () =>
      import('./landing/access-confirmed/access-confirmed').then(
        (m) => m.AccessConfirmedComponent,
      ),
  },
  {
    path: 'legal/privacy',
    loadComponent: () => import('./legal/privacy/privacy').then((m) => m.PrivacyComponent),
  },
  {
    path: 'legal/terms',
    loadComponent: () => import('./legal/terms/terms').then((m) => m.TermsComponent),
  },
  {
    path: 'oportunidades',
    loadComponent: () =>
      import('./opportunities/opportunities').then((m) => m.OpportunitiesComponent),
    canActivate: [authGuard],
  },
  {
    path: 'seguimiento',
    loadComponent: () =>
      import('./seguimiento/seguimiento').then((m) => m.SeguimientoComponent),
    canActivate: [authGuard],
  },
  {
    path: 'auth/register',
    loadComponent: () => import('./auth/register/register').then((m) => m.RegisterComponent),
    canActivate: [redirectAuthenticatedGuard],
  },
  {
    path: 'auth/login',
    loadComponent: () => import('./auth/login/login').then((m) => m.LoginComponent),
    canActivate: [redirectAuthenticatedGuard],
  },
  {
    path: 'auth/check-email',
    loadComponent: () =>
      import('./auth/check-email/check-email').then((m) => m.CheckEmailComponent),
  },
  {
    path: 'auth/verify-email',
    loadComponent: () =>
      import('./auth/verify-email/verify-email').then((m) => m.VerifyEmailComponent),
  },
  {
    path: 'auth/forgot-password',
    loadComponent: () =>
      import('./auth/forgot-password/forgot-password').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'auth/reset-password',
    loadComponent: () =>
      import('./auth/reset-password/reset-password').then((m) => m.ResetPasswordComponent),
  },
  {
    path: '**',
    redirectTo: 'oportunidades',
  },
];
